/**
 *	map.directive.js
 */

import mapTpl from './map.tpl.html!text';
import MapCtrl  from './map.ctrl.js';

var map = function() {
 	return {
 		restrict: 'E',
 		template: mapTpl,
 		scope: {
 			openShopDetailsUrlInNewWindow: '@'
 		},
 		controller: MapCtrl,
 		controllerAs: 'ctrl'
 	};
 };

 export default map;